import { CommentIF, ContentIF } from "../types";

export function getSortedContents(contents:ContentIF[]) {
    contents.sort((a:ContentIF, b:ContentIF) => {
        return +new Date(b.createdAt) - +new Date(a.createdAt);
    });

    return contents;
}

export function getSortedComments(comments:CommentIF[]) {
    comments.sort((a:CommentIF, b:CommentIF) => {
        return +new Date(b.date) - +new Date(a.date);
    });

    return comments;
}

export function getDate(){
    let date = new Date();
    let year = date.getFullYear();
    let month = (date.getMonth() + 1).toString();
    let day = date.getDate().toString();
    let hour = date.getHours().toString();
    let min = date.getMinutes().toString();
    let sec = date.getSeconds().toString();

    month = (month.length < 2) ? '0'+month : month;
    day = (day.length < 2) ? '0'+day : day;
    hour = (hour.length < 2) ? '0'+hour : hour;
    min = (min.length < 2) ? '0'+min : min;
    sec = (sec.length < 2) ? '0'+sec : sec;
    
    return {year, month, day, hour, min, sec};
}